import Err from '../../models/err';

export default function tooLongError(attrName, length, optLabel) {
  return new Err({
    code: Err.Code.TOO_LONG,
    attr: attrName,
    detail: `${optLabel || attrName} cannot be longer than ${length}`,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/error/create_too_long_error.js